import moment from "moment";

/**
 * Format a no. in currency amount
 * @param num
 * @param maxFractionDigits
 */
export const currencyAmountFormat = (num: number, maxFractionDigits = 0, minFractionDigits = 0) => {
  return (!!num || num === 0)
    ? num.toLocaleString("en-IN", {
        maximumFractionDigits: maxFractionDigits,
        minimumFractionDigits: minFractionDigits,
        style: "currency",
        currency: "INR",
      })
    : "";
};

export const floatPriceValue = (val: string | number) => {
  let num = Number(val);
  return Number(num.toFixed(2));
};

/**
 * This function takes dateString as input and formats it in `DD MMM[,] hh:mm A` form.
 * @param dateString
 */
export const getFormattedDateTime = (dateString: string) => {
  return moment(dateString)?.format("DD MMM[,] hh:mm A");
};

/**
 * This function takes inputStr and converts it to title case by capitalizing first letter of each word
 * @param inputStr
 */
export function convertToTitleCase(inputStr: string) {
  let words = inputStr.toLowerCase().split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1);
  }
  return words.join(" ");
}

/**
 * This function takes space seperated inputStr, joins its words and converts it to camel case
 * @param inputStr
 */
export function convertToCamelCase(inputStr: string) {
  let words = inputStr.toLowerCase().split(" ");
  for (let i = 1; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1);
  }
  return words.join("");
}

/**
 * This function takes space seperated inputStr, joins its words and converts it to pascal case
 * @param inputStr
 */
export function convertToPascalCase(inputStr: string) {
  let words = inputStr.toLowerCase().split(" ");
  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substring(1);
  }
  return words.join("");
}

/**
 * Converts time in minutes into "H h MM m SS s", "MM m SS s", "SS s" format
 */
export function convertTimeToHmsFormat(numOfMinutes: number) {
  let numOfHours = Math.floor(numOfMinutes / 60),
    remainingMinutes = Math.floor(numOfMinutes % 60),
    fractionalMinutes = numOfMinutes % 1,
    remainingSeconds = Math.round(fractionalMinutes * 60);
  return `${numOfMinutes >= 60 ? numOfHours + 'h ' : ''} 
          ${numOfHours >= 1 || remainingMinutes >= 1
      ? remainingMinutes.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
      }) + 'm'
      : ''
    } 
          ${remainingSeconds.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
    })}s`;
}